import { TranscriptionMessage } from 'src/models';

export const downloadTranscription = (
  messages: TranscriptionMessage[],
  config: { roles: Record<string, { label: string }>; filename?: string }
) => {
  const { roles, filename } = config;

  const blob = new Blob(
    [
      messages
        .map((msg) => {
          const sender = roles[msg.role!]?.label || msg.role;
          return `${sender}:\n${msg.content}\n`;
        })
        .join('\n'),
    ],
    { type: 'text/plain' }
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'transcription.txt';
  a.click();
};
